export default "__VITE_ASSET__de454b9c__"